export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '© $YEAR$ Radici rinnovabili',
    address: '',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
